module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div>' +
((__t = ( name )) == null ? '' : __t) +
'</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/pages/user/name.tpl
// module id = 481
// module chunks = 0